import axios from 'axios';
import useSWR, { SWRResponse } from 'swr';

const getNowTime = async (): Promise<Date> => {
  const { data } = await axios.get('/api/time');
  const nowDate = new Date(data);

  return nowDate;
};

export const useNowTime = (): SWRResponse<Date, Error> => {
  return useSWR<Date, Error>(
    ['date'],
    getNowTime
  );
};
